<template>
  <div class="row slim-grid-row">
    <!-- ROOM TYPE -->
    <div class="col-4">
      <div class="sticky mb-1"
        :class="{
          'top-5':(!header_scroll || show_rate || show_rate_breakdown) && getMerchant().booking_engine_header_type == 'BANNER',
          'top-90':(!header_scroll || show_rate || show_rate_breakdown) && getMerchant().booking_engine_header_type == 'NAVBAR'}"
        style="top: 165px;">
        <div class="bg-white rounded-4 my-2 light-card-shadow">
          <div class="row slim-grid-row">
            <div class="col-12 mb-1">
              <div class="position-relative">
                <template v-if="type.image == 0">
                  <div class="carousel-cell w-100">
                    <div class="h-img-nearby">
                      <img src="https://guestapps.s3-ap-southeast-1.amazonaws.com/noimage.png"
                        class="object-fit rounded-4 w-100 h-img-nearby">
                    </div>
                  </div>
                </template>
                <template v-else>
                  <flickity ref="flickity" class="room-detail h-img-nearby text-center"
                    :options="flickityOptionsRoom">
                    <div class="carousel-cell w-100" 
                      :id="slider_room_type.id"
                      @mouseover="sliderPreviousNext(true)"
                      @mouseleave="sliderPreviousNext(false)"
                      v-for="slider_room_type in type.image">
                      <div class="h-img-nearby">
                        <img :src="slider_room_type.image_url"
                          class="object-fit rounded-4 w-100 h-img-nearby">
                      </div>
                    </div>
                  </flickity>
                  <div class="slider-action-btn prev" @click="slideTheSlider('prev')">
                    <svg class="transform-180" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="11" cy="11" r="10.5" transform="rotate(-180 11 11)" fill="white" stroke="#D9D9D9"/>
                      <path d="M13.4816 10.9821C13.4816 10.8609 13.4332 10.7398 13.3411 10.6574L9.49798 6.90636C9.41559 6.82398 9.30897 6.77551 9.18782 6.77551C8.93581 6.77551 8.74196 6.96454 8.74196 7.21652C8.74196 7.33769 8.79042 7.44914 8.86796 7.53156L12.6626 11.2438V10.7252L8.86796 14.4375C8.79042 14.515 8.74196 14.6265 8.74196 14.7525C8.74196 15.0045 8.93581 15.1935 9.18782 15.1935C9.30897 15.1935 9.41559 15.145 9.50283 15.0626L13.3411 11.3116C13.4332 11.2196 13.4816 11.1081 13.4816 10.9821Z" fill="black" fill-opacity="0.85"/>
                    </svg>
                  </div>
                  <div class="slider-action-btn next" @click="slideTheSlider('next')">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="11" cy="11" r="10.5" transform="rotate(-180 11 11)" fill="white" stroke="#D9D9D9"/>
                      <path d="M13.4816 10.9821C13.4816 10.8609 13.4332 10.7398 13.3411 10.6574L9.49798 6.90636C9.41559 6.82398 9.30897 6.77551 9.18782 6.77551C8.93581 6.77551 8.74196 6.96454 8.74196 7.21652C8.74196 7.33769 8.79042 7.44914 8.86796 7.53156L12.6626 11.2438V10.7252L8.86796 14.4375C8.79042 14.515 8.74196 14.6265 8.74196 14.7525C8.74196 15.0045 8.93581 15.1935 9.18782 15.1935C9.30897 15.1935 9.41559 15.145 9.50283 15.0626L13.3411 11.3116C13.4332 11.2196 13.4816 11.1081 13.4816 10.9821Z" fill="black" fill-opacity="0.85"/>
                    </svg>
                  </div>
                </template>
                <div :id="type.id" class="position-absolute cursor-pointer" style="right: 10px;bottom: 10px;" @click="$copyText(room_type_url,`${$t('hotel.unit-type.'+type.type+'.unit')} URL copied!`)">
                  <img src="../../../../assets/img/icon/share-outline-white.svg" width="30">
                </div>
                <b-tooltip :target="type.id" placement="right" :title="`Share ${$t('hotel.unit-type.'+type.type+'.unit')} via url`">
                </b-tooltip>
              </div>
            </div>
          </div>
          <div class="pt-2 pb-3 px-3 position-relative">
            <!-- ROOM TYPE NAME -->
            <div class="mb-3">
              <p class="mb-0 body-2-2 font-bold text-20 d-block cursor-pointer" @click="onBack('room_type_detail', type);onBack('handlePopupFilter', 'detail-room')">{{type.name}}</p>
            </div>

            <!-- SPECIFICATION -->
            <div class="w-100 mb-4">
              <div class="row slim-grid-row">
                <div class="col-5 mb-3" v-if="!(type.room_size == null || type.room_size == '' || type.room_size == 0)">
                  <p class="mb-0 body-3 lh-1">{{$t('hotel.unit-type.'+type.type+'.size')}}</p>
                  <div class="w-100">
                    <i class="simple-icon-size-fullscreen text-green text-14 d-inline-block align-middle mr-1 font-weight-bold"></i>
                    <p class="mb-0 body-2-1 d-inline-block align-middle">{{type.room_size}}m²</p>
                  </div>
                </div>
                <div class="col-7 mb-3" v-if="!(type.total_rooms == null || type.total_rooms == '' || type.total_rooms == 0)">
                  <p class="mb-0 body-3 lh-1">Total Unit</p>
                  <div class="w-100">
                    <i class="simple-icon-home text-green text-14 d-inline-block align-middle mr-1 font-weight-bold"></i>
                    <p class="mb-0 body-2-1 d-inline-block align-middle">{{type.total_rooms}} {{$pluralWord(type.total_rooms,'Room')}}</p>
                  </div>
                </div>
                <div class="col-12" v-if="type.bed.length > 0">
                  <p class="mb-0 body-3 lh-1">{{$t('hotel.room-type.bed-type')}}</p>
                  <div class="w-100">
                    <i class="simple-icon-grid text-green text-14 d-inline-block align-middle mr-1 font-weight-bold"></i>
                    <p class="mb-0 body-2-1 d-inline-block align-middle">
                      <template v-for="(bed, index) in type.bed">
                        {{bed.qty}} {{bed.name}}
                        <span v-if="index + 1 < type.bed.length">, </span>
                      </template>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <!-- BUTTON DETAIL -->
            <div class="w-100">
              <p class="mb-0 body-2-1 d-table ml-auto cursor-pointer text-green border-bottom-green"
                @click="onBack('room_type_detail', type);onBack('handlePopupFilter', 'detail-room');postLog('SEARCH','room');hitGoogleAnalytics('room_detail')"
                style="margin-top: -5px">
                {{$t('hotel.unit-type.'+type.type+'.detail')}}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ROOM RATE LIST -->
    <div class="col-8">
      <div class="rounded-4 pt-2">
        <div class="mb-1 position-relative">
          <div class="bg-white px-4 py-3 mb-1 rate-desktop rounded-4 light-card-shadow"
            :class="{
              'z-index-1045 position-relative rate-desktop-white box-shadow-none':is_booking_dropdown == data.id || show_rate == data.id,
              'border-2-green': checkRoomRateHihglight(index)
            }"
            v-for="(data, index) in type.room_rate.slice(0, length_more)">

            <div class="px-3 py-2 bg-green position-absolute" style="top:0px;left:0px;border-radius: 0px 0px 4px 0px;" v-if="checkRoomRateHihglight(index)">
              <p class="mb-0 body-2-4 text-white">{{getBeSortBy()=='room_type'?'LOWEST PRICE':getBeSortBy()=='promotion'?'BIGGEST DISCOUNT':'BEST DEAL'}}</p>
            </div>

            <div class="row slim-grid-row">
              <!-- GENERAL INFORMATION -->
              <div class="col-8 col-md-6 col-lg-7 col-xl-8 mb-1" :class="{'pt-4 mt-2':checkRoomRateHihglight(index)}">
                <!-- name rate -->
                <div class="d-block">
                  <p class=" body-2-2 font-bold text-18 d-block mb-0" style="margin-bottom: -3px">{{data.name}}
                  </p>

                  <div class="w-100 mt-1" v-if="data.bookable && $roomAvbl(data.room_type.id,data.id) > 0">
                    <!-- all promo -->
                    <template v-if="data.best_price.promotion_price < 0 && $roomAvbl(data.room_type.id,data.id) > 0">
                      <div class="py-1 px-2 border-orange lh-1 rounded-4 d-table" v-if="promotionCounter(data.dates) != ''">
                        <p class="mb-0 body-3-3-2 text-orange">{{promotionCounter(data.dates)}}</p>
                      </div>
                    </template>
                  </div>

                  <!-- HIGHTLIGHT -->
                  <ul class="pl-3 my-2">
                    <li><p class="mb-0 body-2-2">{{data.minimum_deposit_value > 0 ? 'Prepayment is required' : 'No Prepayment required'}}</p></li>
                    <li><p class="mb-0 body-2-2">{{data.cancellation_policy.title}}</p></li>
                    <li><p class="mb-0 body-2-2" :class="data.rate.is_included_breakfast?'text-success':'text-danger'">{{data.rate.is_included_breakfast?'Breakfast Included':'No meal included'}}</p></li>
                  </ul>
                  <!-- BUTTON RATE DETAIL -->
                  <p v-if="!checkRoomRateDetailInline(index,data)" class="mb-0 body-3-1 d-table cursor-pointer text-green border-bottom-green"
                  @click="onBack('toggleRateBreakdown', 'rates-breakdown', data.id);onBack('handlePopupFilter', 'rate-breakdown');totalGuestIncluded(data)">
                    {{show_rate_breakdown == data.id?'Hide':'Rate'}} Detail
                  </p>
                </div>
              </div>

              <!-- PRICE AND BUTTON -->
              <div class="col-4 col-md-6 col-lg-5 col-xl-4 mb-1">
                <div class="d-block text-right">
                  <template v-if="data.bookable && $roomAvbl(data.room_type.id,data.id) > 0">
                    <div class="d-block text-right" v-if="checkDiscount(data.dates)">
                      <div class="w-100" v-if="promotionTimeChecker(data.dates)">
                        <p class="body-2-2 text-14 mb-0">Promo ends in <span class="mb-0 px-1 bg-orange mr-1 text-white radius-0 font-bold">{{promo_left.h}}</span>:<span class="mb-0 px-1 bg-orange ml-1 text-white radius-0 font-bold">{{promo_left.m}}</span></p>
                      </div>
                      <p class="mb-0 body-2-2 text-orange text-14 d-inline-block text-right" v-if="discountAccumulation(getTotalPriceFromDate(data.dates,'final_price'), (getTotalPriceFromDate(data.dates,'price')+getTotalPriceFromDate(data.dates,'extra_guest_price'))) < 1">
                        1% OFF
                      </p>
                      <p class="mb-0 body-2-2 text-orange text-14 d-inline-block text-right" v-else>
                        {{discountAccumulation(getTotalPriceFromDate(data.dates,'final_price'), (getTotalPriceFromDate(data.dates,'price')+getTotalPriceFromDate(data.dates,'extra_guest_price')))}}% OFF
                      </p>
                      <p class="mb-0 body-2 text-line-through d-inline-block">
                        {{formatCurrency(getTotalPriceFromDate(data.dates,'price')+getTotalPriceFromDate(data.dates,'extra_guest_price'))}}</p>
                    </div>
                    <p class="mb-0 body-2-2 text-24 text-orange font-semibold">
                      {{formatCurrency(getTotalPriceFromDate(data.dates,'final_price'))}}</p>
                    <p class="mb-0 body-2 text-12 font-semibold">/ {{$t('hotel.unit-type.'+type.type+'.per-unit')}}</p>
                    <p class="mb-0 body-3-3-1">{{$t('general.includes-taxes-and-fees')}}</p>
                  </template>
                </div>
                <div class="row slim-grid-row">
                  <div class="col-2"></div>
                  <div class="col-10">
                    <div class="text-right">
                      <div class="position-relative" style="bottom: 0">
                        <template v-if="data.bookable">
                          <template v-if="getQty(data.id) != 0">
                            <button 
                              v-if="data.room_type.is_virtual"
                              type="button" 
                              class="button-secondary bg-white text-orange px-3 py-2 mt-2 text-12">
                                Selected
                            </button>
                            <button 
                              v-else
                              type="button" 
                              class="button-secondary bg-white text-orange px-3 py-2 mt-2 text-12"
                              :class="{'position-relative z-index-1042':is_booking_dropdown == data.id}"
                              @click="onBack('toggleBookingRate',data.id);checkAvailability(data)">
                              {{getQty(data.id)}} 
                              <span v-if="getQty(data.id) > 1">{{$t('hotel.unit-type.'+type.type+'.units')}}</span> 
                              <span v-else>{{$t('hotel.unit-type.'+type.type+'.unit')}}</span> 
                                <i 
                                class="simple-icon-arrow-up position-relative" 
                                style="top: 2px;" 
                                v-if="is_booking_dropdown == data.id"></i>
                                <i 
                                class="simple-icon-arrow-down position-relative" 
                                style="top: 2px;" 
                                v-else></i>
                            </button>
                          </template>
                          <template v-else>
                            <template v-if="$roomAvbl(data.room_type.id,data.id) > 0">
                              <button 
                                type="button" 
                                class="button-secondary px-3 py-2 mt-2 text-12"
                                @click="addRoomRate(1, data)"
                                v-if="data.room_type.is_virtual">{{$t('hotel.book-now')}} 
                              </button>
                              <button 
                                type="button" 
                                class="button-secondary px-3 py-2 mt-2 text-12"
                                :class="{'position-relative z-index-1042':is_booking_dropdown == data.id}"
                                @click="onBack('toggleBookingRate',data.id);checkAvailability(data)"
                                v-else>{{$t('hotel.book-now')}} 
                                  <i 
                                  class="simple-icon-arrow-up position-relative" 
                                  style="top: 2px;" 
                                  v-if="is_booking_dropdown == data.id"></i>
                                  <i 
                                  class="simple-icon-arrow-down position-relative" 
                                  style="top: 2px;" 
                                  v-else></i>
                              </button>
                            </template>
                            <button type="button" class="button-disabled border-none px-4 py-2 rounded-4 text-center cursor-disable mt-1" style="box-shadow: 0px 6px 12px #eeeeee3b" v-else>
                              <p class="mb-0 body-2-2 font-semibold text-disabled">{{$t("hotel.sold-out")}}</p>
                            </button>
                          </template>
                          <div class="mt-2" 
                            v-if="showRoomLeft(data.room_type.id,data.id)">
                            <p class="mb-0 body-3-3-2 text-danger"> 
                                 {{printRoomLeft($roomAvbl(data.room_type.id,data.id))}}</p>
                          </div>
                        </template>
                        <template v-else>
                          <button :id="`btn-not-available-${data.id}`" type="button" class="button-disabled border-none px-3 py-2 rounded-4 text-center cursor-disable mt-1 d-flex align-items-center ml-auto" style="box-shadow: 0px 6px 12px #eeeeee3b">
                            <p class="mb-0 body-2-2 font-semibold text-disabled">Not Available</p><i class="simple-icon-question ml-2 text-disabled"></i>
                          </button>
                          <b-tooltip :target="`btn-not-available-${data.id}`" triggers="hover" placement="bottom">
                            <div class="p-2" v-html="printNotAvailableRoomMessage(data)">
                            </div>
                          </b-tooltip>
                        </template>
                      </div>
                    </div>
                    <transition name="fade">
                      <div
                        class="position-absolute bg-white border mt-2 rooms-guest rounded-4 z-index-1038"
                        style="right: -10px;width: 125px;box-shadow: 0px 0px 20px 2px #0000001f"
                        v-if="is_booking_dropdown == data.id">
                        <template v-for="(n, index) in $roomAvbl(data.room_type.id,data.id,true)">
                          <p v-if="n < 6"
                          :class="{'text-green':selected_room_rate == n}"
                          class="mb-0 border-bottom body-2-2 text-14 font-semibold py-2 cursor-pointer text-center hover"
                          @click="toggleBookingRateCart('toggleBookingRateCart', 'add', data, n);addRoomRate(n, data);onBack('handlePopupFilter', false)">
                          {{n}} <span v-if="n > 1">{{$t('hotel.unit-type.'+type.type+'.units')}}</span><span v-else>{{$t('hotel.unit-type.'+type.type+'.unit')}}</span> 
                            <i v-if="selected_room_rate == n" style="left: 4px" class="text-green simple-icon-check position-relative"></i>
                          </p>
                          <p 
                          v-else 
                          class="mb-0 border-bottom body-2-2 text-14 font-semibold py-2 cursor-pointer text-center hover" 
                          @click="moreNight(data)">{{$t('hotel.more-rooms')}} 
                            <span class="text-green" v-if="selected_room_rate > 5">({{$t('hotel.current')}} {{selected_room_rate}})</span>
                          </p>
                        </template>
                      </div>
                    </transition>
                  </div>
                </div>
              </div>

              <div 
                class="col-12" 
                v-if="checkRoomRateDetailInline(index,data)">
                <div class="border-top mt-3 py-3">
                  <!-- DESCRIPTION -->
                  <div v-if="$isNotEmpty(data.description_room_rate) || $isNotEmpty(data.description_promotion)">
                    <p class="mb-1 body-2-4">{{$t('general.description')}}</p>
                    
                    <p v-if="$isNotEmpty(data.description_room_rate)" class="mb-0 body-2-1 text-14 font-regular" v-html="$convertNewlinesToBr(data.description_room_rate)"></p>
                    
                    <span v-if="$isNotEmpty(data.description_room_rate) && $isNotEmpty(data.description_promotion)" class="my-2 w-100 d-block"></span>
                    
                    <p v-if="$isNotEmpty(data.description_promotion)" class="mb-0 body-2-1 text-14 font-regular" v-html="$convertNewlinesToBr(data.description_promotion)"></p>

                  </div>

                  <!-- RATE INCLUSIONS -->
                  <div class="mt-3" v-if="data.rate.inclusion.length > 0">
                    <p class="mb-1 body-2-4">{{$t('hotel.room-type.include-in-rate')}}</p>
                    <ul  class="pl-3">
                      <li class="mb-2" v-for="(inclusion, index) in data.rate.inclusion">
                        <span class="body-2-1 d-block">{{inclusion.inclusion_item.name}}</span>
                        <span class="body-2 restrict-p-mb html-desc" v-html="inclusion.inclusion_item.description"></span>
                      </li>
                    </ul>
                  </div>

                  <!-- BUTTON RATE DETAIL -->
                  <p class="mb-0 body-3-1 d-table cursor-pointer text-green border-bottom-green mt-3"
                  @click="onBack('toggleRateBreakdown', 'rates-breakdown', data.id);onBack('handlePopupFilter', 'rate-breakdown');totalGuestIncluded(data)">
                    {{show_rate_breakdown == data.id?'Hide':'Rate'}} Detail
                  </p>
                </div>
              </div>
            </div>

            <!-- DETAIL -->
            <transition name="fade">
              <div v-if="show_rate_breakdown == data.id">
                <div class="border-top mt-3 ">
                  <!-- DESCRIPTION -->
                  <div v-if="$isNotEmpty(data.description_room_rate) || $isNotEmpty(data.description_promotion)">
                    <p class="pt-4 mb-1 body-3-3 text-16 font-bold">{{$t('general.description')}}</p>
                    <p v-if="$isNotEmpty(data.description_room_rate)" class="mb-0 body-3-3 text-14 font-regular" v-html="$convertNewlinesToBr(data.description_room_rate)"></p>
                    <span v-if="$isNotEmpty(data.description_room_rate) && $isNotEmpty(data.description_promotion)" class="my-2 w-100 d-block"></span>
                    <p v-if="$isNotEmpty(data.description_promotion)" class="mb-0 body-2-1 text-14 font-regular" v-html="$convertNewlinesToBr(data.description_promotion)"></p>
                  </div>

                  <!-- CANCELLATION POLICY -->
                  <template v-if="data.cancellation_policy != null">
                    <div class="d-block mb-3 mt-4">
                      <p class="mb-1 body-3-3 text-16 font-bold">{{data.cancellation_policy.title}}</p>
                      <p class="mb-0 body-3-3 text-14 font-regular html-desc" v-html="data.cancellation_policy.description"></p>
                    </div>
                  </template>

                  <!-- TERMS & CONDITIONS -->
                  <template v-if="$isNotEmpty(data.term_and_condition_room_rate) || $isNotEmpty(data.term_and_condition_promotion)">
                    <div class="d-block mb-3 mt-4">
                      <div class="mb-3" v-if="$isNotEmpty(data.term_and_condition_room_rate)">
                        <p class="mb-1 body-3-3 text-16 font-bold">{{data.term_and_condition_room_rate.title}}</p>
                        <p class="mb-0 body-3-3 text-14 font-regular html-desc" v-html="data.term_and_condition_room_rate.description"></p>
                      </div>
                      <div v-if="$isNotEmpty(data.term_and_condition_promotion)">
                        <p class="mb-1 body-3-3 text-16 font-bold">{{data.term_and_condition_promotion.title}}</p>
                        <p class="mb-0 body-3-3 text-14 font-regular html-desc" v-html="data.term_and_condition_promotion.description"></p>
                      </div>
                    </div>
                  </template>

                  <!-- RATE INCLUSIONS -->
                  <template v-if="data.rate.inclusion.length > 0">
                    <p class="pt-3 mb-1 body-3-3 text-16 font-bold">{{$t('hotel.room-type.include-in-rate')}}</p>
                    <div class="height-auto">
                      <ul  class="pl-3">
                        <li class="mb-2" v-for="(inclusion, index) in data.rate.inclusion">
                          <span class="body-2-1 d-block">{{inclusion.inclusion_item.name}}</span>
                          <span class="body-2 restrict-p-mb html-desc" v-html="inclusion.inclusion_item.description"></span>
                        </li>
                      </ul>
                    </div>
                  </template>
                  <template v-if="data.bookable && $roomAvbl(data.room_type.id,data.id) > 0">
                    <p class="pt-3 mb-2 body-2-2 text-15 font-bold">{{$t('hotel.rate-breakdown.title')}}</p>
                    <div class="row slim-grid-row pb-2" v-for="(rate_breakdown, index) in data.dates">
                      <div class="col-6">
                        <p class="mb-0 body-2-2 font-regular">{{$formatDate(rate_breakdown.date)}} :</p>
                        <!-- PROMO COMBINATION -->
                        <p class="mb-1 body-2 text-12 text-green font-regular" v-if="rate_breakdown.promotion_price < 0 && promotionCounter(rate_breakdown.promo_combine,true) != '' && rate_breakdown.price >= rate_breakdown.final_price">{{promotionCounter(rate_breakdown.promo_combine,true)}}</p>
                      </div>
                      <div class="col-6 text-right">
                        <!-- PROMO COMBINATION -->
                        <div class="w-100 mb-1 no-ws" v-if="rate_breakdown.promotion_price < 0 && promotionCounter(rate_breakdown.promo_combine,true) != ''">
                          <p class="mb-0 d-inline-block align-middle mr-2 body-3-3-2 text-orange">{{ +parseFloat(100-$getPercentage(rate_breakdown.price+rate_breakdown.extra_guest_price,rate_breakdown.final_price,2)).toFixed(2) }}%</p><p class="mb-0 body-2 text-12 font-regular text-line-through d-inline-block align-middle" >
                            {{formatCurrency(rate_breakdown.price+rate_breakdown.extra_guest_price)}}
                          </p>
                        </div>
                        <p class="mb-0 body-2-2 font-semibold underline text-15 d-table float-right hover-here">{{formatCurrency(rate_breakdown.final_price)}}
                        </p>
                        <template>
                          <div class="hover-element bg-white border px-4 py-3 text-left position-absolute box-shadow-bold rounded-4 hover-rates" style="width: 275px">
                            <p class="mb-2 body-2-2 font-bold text-15">{{$t('hotel.rate-breakdown.rates-detail-price')}} : </p>
                            <div class="row slim-grid-row">
                              <div class="col-4 mb-1">
                                <p class="mb-0 body-2-2 font-regular">{{$t('hotel.date.date')}} :</p>
                              </div>
                              <div class="col-8 mb-1 text-right">
                                <p class="mb-0 body-2-2 font-regular">{{$formatDate(rate_breakdown.date)}}</p>
                              </div>
                              <div class="col-12 mt-2">
                                <div class="row slim-grid-row mb-2">
                                  <div class="col-6">
                                    <p class="mb-0 body-3-3-2 font-regular">{{total_guest_included}}x {{$t('hotel.rate-breakdown.guest-included')}}</p>
                                  </div>
                                  <div class="col-6">
                                    <p class="mb-0 body-3-3-2 font-regular text-right">{{formatCurrency(rate_breakdown.price)}}</p>
                                  </div>
                                </div>
                                <!-- extra adult -->
                                <div class="row slim-grid-row mb-2" v-if="rate_breakdown.extra_guest.adult.qty > 0">
                                  <div class="col-6">
                                    <p class="mb-0 body-3-3-2 font-regular">{{rate_breakdown.extra_guest.adult.qty}}x {{$t('hotel.rate-breakdown.extra-adults')}}</p>
                                  </div>
                                  <div class="col-6">
                                    <p class="mb-0 body-3-3-2 font-regular text-right">{{formatCurrency(rate_breakdown.extra_guest.adult.total)}}</p>
                                  </div>
                                </div>
                                <!-- extra child -->
                                <div class="row slim-grid-row mb-2" v-if="rate_breakdown.extra_guest.child.qty > 0">
                                  <div class="col-6">
                                    <p class="mb-0 body-3-3-2 font-regular">{{rate_breakdown.extra_guest.child.qty}}x {{$t('hotel.rate-breakdown.extra-childs')}}</p>
                                  </div>
                                  <div class="col-6">
                                    <p class="mb-0 body-3-3-2 font-regular text-right">{{formatCurrency(rate_breakdown.extra_guest.child.total)}}</p>
                                  </div>
                                </div>
                                <!-- extra infant -->
                                <div class="row slim-grid-row mb-2" v-if="rate_breakdown.extra_guest.infant.qty > 0">
                                  <div class="col-6">
                                    <p class="mb-0 body-3-3-2 font-regular">{{rate_breakdown.extra_guest.infant.qty}}x {{$t('hotel.rate-breakdown.extra-infants')}}</p>
                                  </div>
                                  <div class="col-6">
                                    <p class="mb-0 body-3-3-2 font-regular text-right">{{formatCurrency(rate_breakdown.extra_guest.infant.total)}}</p>
                                  </div>
                                </div>

                                <!-- promotion -->
                                <div class="row slim-grid-row mb-2" v-if="rate_breakdown.promotion_price < 0 && promotionCounter(rate_breakdown.promo_combine,true) != '' && rate_breakdown.price >= rate_breakdown.final_price">
                                  <div class="col-6">
                                    <p class="mb-0 body-3-3-2 font-regular">{{promotionCounter(rate_breakdown.promo_combine,true)}}</p>
                                  </div>
                                  <div class="col-6">
                                    <p class="mb-0 body-3-3-2 font-regular text-right text-orange">-{{formatCurrency((rate_breakdown.price+rate_breakdown.extra_guest_price)-rate_breakdown.final_price)}}</p>
                                  </div>
                                </div>
                              </div>
                              <div class="col-12">
                                <div class="row slim-grid-row mt-2 border-top pt-3">
                                  <div class="col-6">
                                    <p class="mb-0 body-2-2 font-bold">{{$t('hotel.total')}} :</p>
                                  </div>
                                  <div class="col-6 text-right">
                                    <p class="mb-0 body-2-2 font-bold">{{$formatCurrency(rate_breakdown.final_price)}}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </template>
                </div>
                <template v-if="$roomAvbl(data.room_type.id,data.id)">
                  <div class="row slim-grid-row mt-2 border-top pt-2">
                    <div class="col-6">
                      <p class="mb-0 body-2-2 font-semibold text-16">{{$t('hotel.rate-breakdown.full-rates')}} : </p>
                    </div>
                    <div class="col-6 text-right">
                      <p class="mb-0 body-2-2 text-18 font-bold">
                        {{formatCurrency(totalRateBreakdown(data.dates))}}</p>
                    </div>
                  </div>
                </template>
              </div>
            </transition>
          </div>
          <template v-if="type.room_rate.length > 5">
            <div class="rounded-4 text-center border-black cursor-pointer bg-white py-2 mt-2" v-if="rates_more" @click="toggleShowMoreRates(true,type.room_rate.length)">
              <p class="mb-0 body-2-2 font-semibold text-14">{{$t('hotel.show-more-rates')}}</p>
            </div>
            <div class="rounded-4 text-center border-black cursor-pointer bg-white py-2 mt-2" v-else @click="toggleShowMoreRates(false,type.room_rate.length)">
              <p class="mb-0 body-2-2 font-semibold text-14">{{$t('hotel.show-less')}}</p>
            </div>
          </template>
        </div>
      </div>
    </div>
    <!-- Rate select more then 5 -->
    <div v-if="booking_rate_more">
      <div class="position-relative w-100" style="z-index: 1050">
        <div class="row no-gutters justify-content-center">
          <div class="fixed-bottom d-block nav-bottom" style="bottom:0%">
            <div class="custom-container-fluid px-0">
              <div class="justify-content-center no-gutters">
                <div class="w-100 position-relative">
                  <div style="background-color: #00000099">
                    <div class="w-100 py-2 px-2" style="height: 100vh;">
                      <div>
                        <div class="position-relative bg-white" style="z-index: 1051">
                          <div class="row no-gutters justify-content-center">
                            <div class="fixed-bottom d-table w-100 nav-bottom" style="top:220px">
                              <div class="custom-container-fluid px-0">
                                <div class="row justify-content-center no-gutters">
                                  <div class="col-3 bg-white rounded-4 position-relative">
                                    <div class="px-3 py-3">
                                      <p class="mb-3 body-2-2 font-semibold text-16">{{$t('hotel.unit-type.'+type.type+'.more-unit')}}</p>
                                      <div class="my-2 text-center">
                                        <p class="body-3-3 mb-2" v-if="showRoomLeft(booking_rate_more.room_type.id,booking_rate_more.id)">{{printRoomLeft($roomAvbl(booking_rate_more.room_type.id,booking_rate_more.id))}}</p>
                                        <input 
                                        @keypress="inputCustomOnly" 
                                        type="text" 
                                        :ref="'inputmore'" 
                                        v-model="more_room"
                                        :placeholder="$t('general.input-here')" 
                                        class="form-control mb-2 text-center font-regular"
                                        :class="{'border-danger':is_room_avlb_not_valid}">
                                        <p v-if="is_room_avlb_not_valid" class="body-3-3 mb-1 text-danger">{{$t('hotel.unit-type.'+type.type+'.more-unit-warning')}}</p>
                                      </div>
                                      <div class="row slim-grid-row pt-2">
                                        <div class="col-6">
                                          <button class="button-black w-100" @click="moreNight(false)">{{$t('general.cancel')}}</button>
                                        </div>
                                        <div class="col-6">
                                          <button disabled="disabled" class="button-primary w-100 button-disabled" v-if="is_room_avlb_not_valid">{{$t('hotel.book-now')}}</button>
                                          <button class="button-primary w-100" @click="addRoomRate(more_room,booking_rate_more);moreNight(false);onBack('toggleBookingRate',false);onBack('handlePopupFilter',false)" v-else>{{$t('hotel.book-now')}}</button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Flickity from 'vue-flickity';
  import {formatCurrency,formatDate,inputCustomOnly} from '@/utils/index.js'
  import {mapGetters,mapMutations} from 'vuex'
  import config from '@/config/index.js'
  import moment from 'moment'

  export default{
    props: ['type','header_scroll','is_booking_dropdown','show_rate','show_rate_breakdown','is_active','discountAccumulation','formatDate','totalRateBreakdown','toggleBookingRate','popup_active','type_index','rt_hightlight_index','type_avlb', 'roomRateHighlight'],
    components:{
      Flickity
    },
    data(){
      return{
        more_policy: true,
        more_inclusions: true,
        prevNext: false,
        flickityOptionsRoom: {
          prevNextButtons: false,
          initialIndex: 0,
          pageDots: true,
          adaptiveHeight: false,
          draggable: false,
          wrapAround: true,
        },
        total_guest_included:'',
        booking_rate_more: false,
        is_popup_avlb: false,
        is_popup_avlb_form: false,
        more_room: 6,
        availability: 0,
        get_data_rates: '',
        length_more: 5,
        rates_more: true,
        action_success:{
          show: false,
          message: '',
          timer: 0
        } 
      }
    },
    computed:{
      is_room_avlb_not_valid(){
        let display = 0
        if (this.more_room == '' || this.more_room == 0 || this.more_room > this.$roomAvbl(this.booking_rate_more.room_type.id,this.booking_rate_more.id)) {
          display = true
        } 
        return display
      },
      selected_room_rate(){
        let display = 0
        if(this.getBeCartRoom().length > 0){
          let record = this.getBeCartRoom().findIndex(x=>x.room_rate.id == this.get_data_rates.id)
          if(record != -1){
            display = this.getBeCartRoom()[record].qty
          }
        }
        return display
      },
      show_success(){
        return this.action_success.show
      },
      promo_left(){
        let time_end = moment().hour(23).minute(59).second(59)
        let time_now = moment()
        let timer = moment.duration(moment(time_end).diff(moment(time_now)))
        let return_data = {
          h: timer.hours() > 10 ? timer.hours() : '0'+timer.hours(),
          m: timer.minutes() > 10 ? timer.minutes() : '0'+timer.minutes()
        }
        return return_data
      },
      room_type_url(){
        var full_url = `${window.location.origin}/${this.getMerchant().code}/hotel-direct-detail/room_type/room_type/${this.type.id}`;
        return full_url
      }
    },
    watch:{
      show_success(){
        if (this.action_success.show) {
          let looping = setInterval(() => {
            if (this.action_success.timer > 0) {
              this.action_success.timer--
            }else if(this.action_success.timer == 0){
              this.action_success.show = false
              this.action_success.message = ''
              clearInterval(looping)
            }
          },1000) 
        }
      }
    },
    methods:{
      ...mapGetters(['getBeSortBy','getBeFilter','getBeCartRoom','getBeRoomAvbl','getMerchant','getCurrentLanguage']),
      ...mapMutations(['BeManipulateRoomRate','changeBeRoomAvbl','beRemoveRoomRate','BeManipulateRoomRateGuest']),
      inputCustomOnly($event){
        inputCustomOnly('number',$event)
      },
      formatCurrency(value){
        return formatCurrency(value);
      },
      printRoomLeft(qty){
        if(this.getCurrentLanguage() == 'en' && qty == 1){
          return `${qty} ${this.$t('hotel.unit-type.'+this.type.type+'.unit')} left`
        }else{
          return `${qty} ${this.$t('hotel.unit-type.'+this.type.type+'.units')} left`
        }
      },
      checkRoomRateHihglight(roomRateIndex){
        let validRoomType = this.roomRateHighlight.roomTypeIndex === this.type_index;
        let validRoomRate = this.roomRateHighlight.roomRateIndex === roomRateIndex;
        return validRoomType && validRoomRate;
      },  
      checkRoomRateDetailInline(roomRateIndex, roomRate){
        const isDetailShown = this.show_rate_breakdown === roomRate.id
        const isDataEmpty = this.$isEmpty(roomRate.description_room_rate) && this.$isEmpty(roomRate.description_promotion) && this.$isEmpty(roomRate.rate.inclusion);        
        if(isDetailShown || isDataEmpty) return false

        const isHightlight = this.checkRoomRateHihglight(roomRateIndex);
        const isRoomRateAloneAndAvailable = this.type.room_rate.length == 1 && this.type_avlb > 0;
        const isBookable = roomRate.bookable;
        if(isBookable && (isHightlight || isRoomRateAloneAndAvailable)) return true;

        return false;
      },
      printNotAvailableRoomMessage(roomRate){
        if(!roomRate) return '';
        
        if(roomRate.stop_sell) return 'Sorry, the room you selected is unavailable for booking on the chosen dates.';

        let { check_in, check_out } = this.getBeFilter().date
        
        if(roomRate.closed_to_arrival){
          const checkinDate = this.$formatDate(check_in);
          return `Sorry, we cannot accept new arrivals for check-in on <b>${checkinDate}</b>. Please choose a different check-in date.`;
        }
        
        if(roomRate.closed_to_departure){
          const checkoutDate = this.$formatDate(check_out);
          return `Sorry, check-out on <b>${checkoutDate}</b> is not available. Please adjust your stay by extending or shortening your booking.`;
        }

        const totalNightStay = this.$countDays(check_in, check_out);
        
        if(totalNightStay < roomRate.min_nights) return `Sorry, the room requires a minimum stay of <b>${roomRate.min_nights} ${this.$pluralWord(roomRate.min_nights, 'night')}</b>. Please extend your stay to meet the requirement.`;
        
        if(totalNightStay > roomRate.max_nights) return `Sorry, the maximum stay for this room is <b>${roomRate.max_nights} ${this.$pluralWord(roomRate.max_nights, 'night')}</b>. Please shorten your booking to fit within the allowed stay.`;
        
      },
      showRoomLeft(rt_id,rr_id){
        let indicator = this.getMerchant().room_availability_max_show
        let room_left = this.$roomAvbl(rt_id,rr_id)
        let is_not_show = indicator == 0
        let is_show_all = indicator == null
        let show_limited = room_left <= indicator

        if(is_not_show || room_left == 0) return false
        else if(is_show_all || show_limited) return true
      },
      checkDiscount(data){
        let total_promo_price = 0

        data.forEach(date=>{
          if(date.promo_combine != null){
            let promo_valid = date.promo_combine.promotion_list.filter(x=>x.promotion_type != 'REMAINING_OCCUPANCY' && x.is_apply == true)
            if(promo_valid.length > 0){
              total_promo_price += date.promo_combine.total_promotion_price
            }
          }
        })

        if(total_promo_price < 0){
          return true
        }else{
          return false
        }
      },
      getTotalPriceFromDate(data,return_data){
        let total = 0
        data.forEach(date=>{
          total += date[return_data]
        })
        return total
      },
      postLog(modules,event){
        let e = event
        if(event == 'room'){
          e = this.getBeSortBy() == 'room_type' ? 'Clicked Room Type Detail' : 'Clicked Rate Detail'
        }
        this.$postLog(modules,'',e)
      },
      onBack(type,data1,data2){
        this.$emit(type,data1,data2)
      },
      hitGoogleAnalytics(event){
        if(this.getMerchant().google_analytics_id != null){
          if(this.getMerchant().google_analytics_id != ''){
            this.$gtag('event',event, { method: 'Google' })
          }
        }
      },
      toggleBookingRateCart(button, type, data, qty = 1){
        this.$emit(button,type,data,qty)
      },
      isToggle(type,data){
        if (type == 'policy') {
          this.more_policy = data
        }else if(type == 'inclusions') {
          this.more_inclusions = data
        }
      },
      // PROMO COMBINATION
      promotionCounter(data,is_preview=false){
        let promotion = []
        if(is_preview){
          if(data != null){
            let promotion_list = this.promotionCounterPerDate(data.promotion_list)
            for(let i=promotion_list.length-1;i>=0;i--){
              let item = promotion_list[i]
              if(promotion.length == 0){
                promotion += item.name
              }else{
                promotion += `, ${item.name}`
              }
            }
          }
          return promotion
        }
        else{
          for(let i = 0; i < data.length; i++){
            if(data[i].promo_combine != null){
              let promotion_list_per_date = this.promotionCounterPerDate(data[i].promo_combine.promotion_list)
              promotion = promotion.concat(promotion_list_per_date)
            }
          }
          promotion = promotion.filter((v,i,a)=>a.findIndex(v2=>(v2.id===v.id))===i)
          let display = ''
          if(promotion.length == 1){
            display = promotion[0].name
          }else if(promotion.length > 1){
            display = promotion[promotion.length-1].name+' and '+(promotion.length-1)+' Other'
          }
          return display
        }
      },
      promotionCounterPerDate(promo_list){
        let promotion = []
        promo_list.forEach((item,index)=>{
          let validate = {
            price: item.promotion_price < 0,
            not_ro: item.promotion_type != 'REMAINING_OCCUPANCY',
            is_apply: item.is_apply
          }
          if(validate.price && validate.not_ro && validate.is_apply){
            if(promotion.length == 0){
              promotion.push({
                id: item.id,
                name: item.name
              })
            }else{
              let record = promotion.findIndex(x=>x.id == item.id)
              if(record == -1){
                promotion.push({
                  id: item.id,
                  name: item.name
                })
              }
            }
          }
        })
        return promotion
      },
      promotionTimeChecker(data){
        let today = moment().format('YYYY-MM-DD')
        let total_promo_exp_today = []
        data.forEach(date=>{
          if(date.promo_combine != null){
            let promo_valid = date.promo_combine.promotion_list.filter(x=>x.promotion_type != 'REMAINING_OCCUPANCY' && x.is_apply == true)
            promo_valid.forEach(promo_item=>{
              if(promo_item.is_use_custom_sale_stay_date && today == promo_item.sale_date[0].end_date){
                total_promo_exp_today.push(promo_item)
              }
            })
          }
        })
        return total_promo_exp_today.length > 0 ? true : false
      },
      totalGuestIncluded(data){
        let total = this.getBeFilter().guest.adult+this.getBeFilter().guest.child+this.getBeFilter().guest.infant
        if(total  <= data.rate.guest_included){
          this.total_guest_included = total

        }else{
         this.total_guest_included = data.rate.guest_included
        }
      },
      moreNight(data){
        if (data != false) {
          this.booking_rate_more = data
          let self = this
          this.$nextTick(() => {
            self.$refs['inputmore'].focus()
            self.$refs['inputmore'].select()
          })
        }else{
          this.booking_rate_more = false
        }
      },
      roomRateVisible(avlb){
        return (avlb.index < 5 ) ? avlb.index : 6
      },
      addToCart(data,n){
        if(!n.is_limit){
          this.toggleBookingRateCart('toggleBookingRateCart', 'add', data, n.counter);
          this.addRoomRate(n.counter, data);
          this.onBack('handlePopupFilter', false)
        }
      },
      updateRoomTypeAvailability(qty, currentRoomRate, action){
        const { 
          id: rr_id, 
          room_type: { id, is_virtual, availability_affected } 
        } = currentRoomRate
        let availabilityParams = { 
          id, 
          rr_id, 
          is_virtual, 
          availability_affected, 
          action,
          qty 
        }
        this.changeBeRoomAvbl(availabilityParams);
      },
      generateRemainingGuestFilter(){
        const GUEST_TYPE = ['adult','child','infant'];

        let remainingGuestFilter = this.$deepCopy(this.getBeFilter().guest)
        this.getBeCartRoom().forEach(savedRoomRate => {
          savedRoomRate.guest.forEach(savedRoomRateGuest => {
            const { included, extra } = savedRoomRateGuest;
            
            const savedGuestsPerRoomRate = GUEST_TYPE.reduce((acc, key) => {
              acc[key] = included[key] + extra[key];
              return acc;
            }, {});
            GUEST_TYPE.forEach(guest => {
              if(remainingGuestFilter[guest] > 0){
                remainingGuestFilter[guest] -= savedGuestsPerRoomRate[guest]
              } else {
                remainingGuestFilter[guest] = 0
              } 
            })
          });
        })
        return remainingGuestFilter
      },
      includeGuestParamsIfZeroTotal(guest_included, roomConfig){
        let guestIncluded = { adult: 0, child: 0, infant: 0 }
        const currentGuestFilter = this.$deepCopy(this.getBeFilter().guest)

        const { use_max_guest_by_pax, max_guests, max_guest_adult, max_guest_children, max_guest_infant } = roomConfig
        
        if(use_max_guest_by_pax){
          guestIncluded.adult = Math.min(guest_included, max_guest_adult);

          let remainingPax = guest_included - guestIncluded.adult;

          if (currentGuestFilter.child > 0 && remainingPax > 0) {
            guestIncluded.child = Math.min(remainingPax, max_guest_children);
            remainingPax -= guestIncluded.child;
          }

          if (currentGuestFilter.infant > 0 && remainingPax > 0) {
            guestIncluded.infant = Math.min(remainingPax, max_guest_infant);
          }
        }else{
          if(currentGuestFilter.adult > guest_included){
            guestIncluded = { adult: guest_included, child: 0, infant: 0 }
          }else{
            guestIncluded.adult = currentGuestFilter.adult
            const remainingGuestIncludedAfterAdult = guest_included - currentGuestFilter.adult
        
            if(remainingGuestIncludedAfterAdult > 0){
              
              if(currentGuestFilter.child > remainingGuestIncludedAfterAdult){
                guestIncluded.child = remainingGuestIncludedAfterAdult
              }else{
                guestIncluded.child = currentGuestFilter.child
                const { adult, child } = guestIncluded
                const remainingGuestIncludedAfterAdultChild = guest_included - (adult + child)
                const isInfantExist = currentGuestFilter.infant > remainingGuestIncludedAfterAdultChild
                if(remainingGuestIncludedAfterAdultChild > 0 && isInfantExist){
                  guestIncluded.infant = remainingGuestIncludedAfterAdultChild
                }
              }
            }
          }
        }
        return guestIncluded;
      },
      allocateGuestPerRoom(guestParamsIncluded, remainingGuestFilter, guest_included){
        let includedGuest = guestParamsIncluded
        let remainingGuest = remainingGuestFilter
        
        const GUEST_TYPE = ['adult','child','infant'];
        GUEST_TYPE.forEach(guest => {
          let totalGuestIncludedPerRoom = Object.values(includedGuest).reduce((sum, value) => sum + value, 0);
          if(remainingGuest[guest] > 0 && totalGuestIncludedPerRoom < guest_included){
            let remainingPaxPerRoom = guest_included - totalGuestIncludedPerRoom
            if(remainingGuest[guest] > guest_included){
              includedGuest[guest] = remainingPaxPerRoom
              remainingGuest[guest] -= remainingPaxPerRoom
            }else{
              includedGuest[guest] = remainingPaxPerRoom > remainingGuest[guest] ? remainingGuest[guest] : remainingPaxPerRoom
              remainingGuest[guest] -= includedGuest[guest]
            }
          }
        });
        return { includedGuest, remainingGuest }
      },
      allocateSpecificGuestPerRoom(remainingGuests, maxGuests, includedGuests){
        let allocatedGuests = { adult: 0, child: 0, infant: 0 };
        let remainingIncluded = includedGuests;

        const allocate = (type) => {
          if (remainingIncluded <= 0) return;
          const count = Math.min(remainingGuests[type], maxGuests[type], remainingIncluded);
          allocatedGuests[type] = count;
          remainingGuests[type] -= count;
          remainingIncluded -= count;
        }

        allocate('adult');
        allocate('child');
        allocate('infant');

        return allocatedGuests;
      },
      generateRoomRateGuestParam(selectedRoomRateQty, currentRoomRate){
        let finalCountGuests = []
        
        const { rate, room_type } = currentRoomRate
        const {
          use_max_guest_by_pax = false,
          max_guests = null,
          max_guest_adult = 0,
          max_guest_children = 0,
          max_guest_infant = 0,
        } = rate.max_guests ? rate : room_type;
        const roomConfig = {use_max_guest_by_pax, max_guests, max_guest_adult, max_guest_children, max_guest_infant}

        const GUEST_TYPE = ['adult','child','infant'];
        let remainingGuestFilter = this.generateRemainingGuestFilter()
        const totalRemainingGuestFilter = Object.values(remainingGuestFilter).reduce((sum, value) => sum + value, 0)

        for (let i = 0; i < selectedRoomRateQty; i++) {
          let guestParams = {
            included: { adult: 0, child: 0, infant: 0 },
            extra: { adult: 0, child: 0, infant: 0 },
          }
          
          if(totalRemainingGuestFilter === 0){
            guestParams.included = this.includeGuestParamsIfZeroTotal(rate.guest_included, roomConfig)
            finalCountGuests.push(guestParams);
          }else{
            
            // Calculate guest included
            if(use_max_guest_by_pax){
              const maxGuests = { adult: max_guest_adult, child: max_guest_children, infant: max_guest_infant };
              guestParams.included = this.allocateSpecificGuestPerRoom(remainingGuestFilter, maxGuests, rate.guest_included);
            }else{
              if(totalRemainingGuestFilter > rate.guest_included){
                const { includedGuest, remainingGuest } = this.allocateGuestPerRoom(guestParams.included, remainingGuestFilter, rate.guest_included)
                guestParams.included = includedGuest
                remainingGuestFilter = remainingGuest
              }else{
                guestParams.included = remainingGuestFilter
                remainingGuestFilter = { adult: 0, child: 0, infant: 0 }
              }
            }
            
            finalCountGuests.push(guestParams);

            // Calculate extra guest
            const isLastLooper = i+1 === selectedRoomRateQty;
            if(isLastLooper){
              let notIncludedGuest = Object.values(remainingGuestFilter).reduce((sum, value) => sum + value, 0)
              if(notIncludedGuest > 0){
                for(let j = 0; j < selectedRoomRateQty; j++){
                  let guestPerQtyRoom = finalCountGuests[j]
                  if(use_max_guest_by_pax){
                    const maxGuestsPerType = { adult: max_guest_adult, child: max_guest_children, infant: max_guest_infant };
                    const guestIncluded = guestPerQtyRoom.included
                    
                    for (const type of GUEST_TYPE){
                      let remainingPaxForExtra = maxGuestsPerType[type] - guestIncluded[type];
                      if(remainingPaxForExtra <= 0) continue;

                      const totalCurrentGuest = Object.values(finalCountGuests[j]).flatMap(Object.values).reduce((a, b) => a + b, 0);
                      if(max_guests <= totalCurrentGuest) continue;

                      const remainingFromMaxGuests = max_guests - totalCurrentGuest;
                      const extraFinal = Math.min(remainingPaxForExtra, remainingGuestFilter[type], remainingFromMaxGuests);
                      finalCountGuests[j].extra[type] = extraFinal;
                      remainingGuestFilter[type] -= extraFinal;
                    }

                  }else{
                    let totalGuestIncludedPerRoom = Object.values(guestPerQtyRoom.included).reduce((sum, value) => sum + value, 0);  
                    let remainingPaxForExtra = max_guests-totalGuestIncludedPerRoom

                    for (const type of GUEST_TYPE) {
                      if (remainingGuestFilter[type] > 0) {
                        const extraFinal = Math.min(remainingPaxForExtra, remainingGuestFilter[type]);
                        finalCountGuests[j].extra[type] = extraFinal;
                        remainingGuestFilter[type] -= extraFinal;
                      }
                      
                    }
                  }
                }
              }
            }
          }
        }

        return finalCountGuests;
      },
      addRoomRate(qty, selectedRoomRate){
        const validQty = parseInt(qty);
        const currentRoomRate = this.$deepCopy(selectedRoomRate)
        
        const savedRoom = this.$deepCopy(this.getBeCartRoom())
        let savedRoomRateIndex = savedRoom.findIndex(savedRoomRate=>savedRoomRate.room_rate.id === currentRoomRate.id)
        
        if(savedRoomRateIndex != -1){
          this.beRemoveRoomRate(currentRoomRate.id);
          this.updateRoomTypeAvailability(savedRoom[savedRoomRateIndex].qty, currentRoomRate, 'inc')
          setTimeout(()=>{
            this.addRoomRate(validQty, currentRoomRate)
          },100)
        } else {
          this.updateRoomTypeAvailability(validQty, currentRoomRate, 'dec')
          const roomRateParam = {
            room_rate: currentRoomRate,
            qty: validQty,
            guest: this.generateRoomRateGuestParam(validQty, currentRoomRate)
          }
          this.BeManipulateRoomRate(roomRateParam)
          setTimeout(()=>{
            this.updatePriceAccordingToPax(currentRoomRate.id, roomRateParam.guest)
          },100)
        }
      },
      updatePriceAccordingToPax(room_rate_id,guests){
        let guest_params = { 
            id: room_rate_id, 
            guest: {
              included: [],
              extra: []
            } 
          }

          guests.forEach((item,index)=>{
            guest_params.guest.included.push(item.included)
            guest_params.guest.extra.push(item.extra)
          })
          
        this.BeManipulateRoomRateGuest(guest_params)
      },
      checkAvailability(data){
        this.get_data_rates = data
        this.availability = data.availability
        this.more_room = this.selected_room_rate
      },
      toggleShowMoreRates(type,length){
        if (this.rates_more) {
          this.length_more = length
          this.rates_more = false
        }else{
          this.length_more = 5
          this.rates_more = true
        }
      },
      sliderPreviousNext(data){
        this.prevNext = data
      },
      copyLink(){
        var params = {
          type : (this.is_active == 'room_type') ? 'room_type' : 'rate',
          sort_by: this.getBeSortBy()
        } 
        var full_url = window.location.origin+"/"+this.getMerchant().code+'/hotel-direct-detail/'+params.type+'/'+params.sort_by+'/'+this.type.id;
        var input_temp = document.createElement("input");
        input_temp.value = full_url;
        document.body.appendChild(input_temp);
        input_temp.select();
        document.execCommand("copy");
        document.body.removeChild(input_temp);
        this.action_success.show = true
        this.action_success.message = 'Link copied!'
        this.action_success.timer = 1
      },
      getQty(id){
        let display = 0
        if(this.getBeCartRoom().length > 0){
          let record = this.getBeCartRoom().findIndex(x=>x.room_rate.id == id)
          if(record != -1){
            display = this.getBeCartRoom()[record].qty
          }
        }else{
          display = 0
        }
        return display
      },
      slideTheSlider(action='next'){
        if(this.$refs.flickity){
          if(action === 'next') this.$refs.flickity.next();
          else this.$refs.flickity.previous();
        }
      }
    }
  }
</script>
<style scoped>

  .rooms-guest:after,
  .rooms-guest:before {
    position: absolute;
    display: inline-block;
    content: "";
    top: -6px;
  }

  .rooms-guest:after {
    border-right: 6px solid transparent;
    border-bottom: 6px solid #fff;
    border-left: 7px solid transparent;
  }

  .rooms-guest:before {
    top: -7px;
    border-right: 7px solid transparent;
    border-left: 7px solid transparent;
    border-bottom: 7px solid #ccc;
  }

  .hover-rates{
    bottom: 25px;
    right: 0;
    z-index: 9;
  }

  .top-90{
    top: 90px !important;
  }
 
</style>


// WEBPACK FOOTER //
// src/components/hotel/be/desktop/room.vue